export class Quote {
    productKey: string;
    productName?: string;
    coverageKey?: string;
    paymentFee?: number;
    totalCost: number;
    monthlyCost: number;
    term?: number;
    paymentMethod?: string;
    franchiseType?: string;
    franchiseValue?: number;
    isSelected?: boolean;
}
